
import { UserListItem } from './UserListItem';
import { UserStats } from './UserStats';
import { ProfileWithOrganization } from './useUserData';
import { Organization } from '@/types/flight';

interface UserListProps {
  profiles: ProfileWithOrganization[];
  organizations: Organization[];
  isDialogOpen: boolean;
  selectedUserId: string | null;
  onEdit: (profile: ProfileWithOrganization) => void;
  onDialogChange: (open: boolean) => void;
  onSubmit: () => void;
}

export function UserList({
  profiles,
  organizations,
  isDialogOpen,
  selectedUserId,
  onEdit,
  onDialogChange,
  onSubmit
}: UserListProps) {
  const activeUsers = profiles.filter(p => p.is_active).length;

  return (
    <div className="space-y-4">
      <UserStats totalUsers={profiles.length} activeUsers={activeUsers} />
      
      {profiles.map((profile) => (
        <UserListItem
          key={profile.id}
          profile={profile}
          organizations={organizations}
          isDialogOpen={isDialogOpen}
          selectedUserId={selectedUserId}
          onEdit={onEdit}
          onDialogChange={onDialogChange}
          onSubmit={onSubmit}
        />
      ))}
      
      {profiles.length === 0 && (
        <div className="text-center py-8 text-muted-foreground">
          No users found. Create your first user to get started.
        </div>
      )}
    </div>
  );
}
